import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {Navigate, useParams} from "react-router";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ManageStatusPageTabContainer} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.tsx";

const MAX_SIGNED_32_BIT_INT = 2147483647;

export const ManageStatuspagePage = () => {
  const {id} = useParams();
  const numericId = Number(id);
  if (!Number.isInteger(numericId) || numericId < 1 || numericId > MAX_SIGNED_32_BIT_INT) {
    return <Navigate to="/statuspages" replace />;
  }

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={"Manage Status Page"}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <Helmet>
        <title>Manage Status Page</title>
      </Helmet>
      <Suspense fallback={<LoadingContainer />}>
        <ManageStatusPageTabContainer />
      </Suspense>
    </UpErrorBoundary>
  );
};
